import { render, staticRenderFns } from "./ImportedProducts.vue?vue&type=template&id=2b1b89c3"
import script from "./ImportedProducts.vue?vue&type=script&lang=js"
export * from "./ImportedProducts.vue?vue&type=script&lang=js"
import style0 from "./ImportedProducts.vue?vue&type=style&index=0&id=2b1b89c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports